import React, { Component } from 'react'
import AddContract from './AddContract'
import ContractsApi from '../../../../../api/Sales/SalesContracts'
import Members from '../../../../../api/Members'
import Clients from '../../../../../api/Sales/Clients'
import { get, isEmpty, omit, pick } from 'lodash'
import { withRouter } from 'react-router-dom'
import { message, Select } from 'antd'
import { arrVal } from '../../../../../modules/Utils'
import _ from 'lodash'
import { compose } from 'recompose'
import withUrlFetch from '../../../../../elements/Select/withUrlFetch'
import withSpinning from '../../../../../elements/HOC/withSpinning'
import withSort from '../../../../../elements/HOC/withSort'
import CustomSelect from '../../../../../elements/Select/CustomSelect'

class AddContractCont extends Component {
  constructor(props) {
    super(props)
    this.key = props.match.params.key
    this.contractKey = get(props.match, 'params.contractKey')
    this.state = {
      submitting: false,
      memberFetching: false,
      clientFetching: false,
      showSkip: false,
      CustomerOrderSelect: Select,
      member: {},
      type: this.contractKey ? 'update' : 'new',
      client: {},
      contract: {},
      current: 0,
    }
    this.contractApi = new ContractsApi()
    this.api = new Clients()
    this.memberApi = new Members()
  }

  async componentDidMount() {
    if (isEmpty(this.state.member)) {
      try {
        this.setState({
          memberFetching: true,
        })
        const client = await this.api.getMember(this.key)
        const memberResponse = await this.memberApi.get(this.key)
        const contactsResponse = await this.memberApi.contacts.get(this.key)
        const contacts = await contactsResponse.json()
        let member = await memberResponse.json()
        let contract = {
          client: {
            address: arrVal(contacts, 'address').find((c) => c.default === true),
          },
        }
        if (this.contractKey) {
          contract = await this.contractApi.get(this.contractKey)
        }
        const CustomerOrderSelect = get(member, '_id')
          ? compose(
              withUrlFetch({
                name: 'cpo',
                url: `cpo/?customer=${get(member, '_id')}&status=Received&select=_id,no`,
                cache: true,
              }),
              withSpinning,
              withSort
            )(CustomSelect)
          : Select
        this.setState({
          member,
          client,
          contract,
          CustomerOrderSelect,
          memberFetching: false,
          clientFetching: false,
        })
      } catch (error) {
        console.error(error)
        message.error(error.errorMessage)
      }
    }
  }

  overviewCmpRef = React.createRef()
  keyTermsCmpRef = React.createRef()
  payrollCmpRef = React.createRef()
  ratesCmpRef = React.createRef()
  linesCmpRef = React.createRef()
  communicationCmpRef = React.createRef()

  updateContract = (attribute, value) => {
    const contract = this.state.contract
    this.setState({
      contract: Object.assign({}, contract, { [attribute]: value }),
    })
  }
  prev = () => {
    const current = this.state.current - 1
    this.setState({ current, showSkip: false })
  }
  next = async () => {
    let valid = false
    this.setState({
      showSkip: true,
    })
    switch (this.state.current) {
      case 0:
        valid = await this.checkOverviewForm()
        break
      case 1:
        valid = await this.checkKeyTermsForm()
        break
      case 2:
        valid = await this.checkPaymentForm()
        break
      case 3:
        valid = await this.checkCommunicationForm()
        break
      default:
        valid = true
    }
    if (valid) {
      const current = this.state.current + 1
      this.setState({ current, showSkip: false })
    }
  }
  skip = () => {
    const current = this.state.current + 1
    this.setState({ current, showSkip: false })
  }
  submit = async () => {
    this.setState({ submitting: true })
    try {
      let contract = this.state.contract
      let lines = get(contract, 'lines') || []
      lines = lines.map((l) =>
        Object.assign({}, omit(l, 'key'), {
          contract: { _id: 'temp' },
        })
      )
      contract = omit(contract, ['_key', 'lines'])
      contract.client = Object.assign({}, contract.client, {
        _id: this.state.client._id,
      })

      await this.contractApi.createWithLines({ contract, lines })
      this.props.history.push({
        pathname: `/clients/${this.key}/`,
        hash: 'contracts',
      })
    } catch (error) {
      message.error(error.errorMessage)
    }
    this.setState({ submitting: false })
  }
  update = async () => {
    let valid = true
    if (valid) {
      this.setState({ submitting: true })
      try {
        let contract = this.state.contract
        contract = omit(contract, ['code', 'revision', 'paid', 'invoiced', 'status', '_history', 'owner'])
        contract.client = Object.assign({}, contract.client, {
          _id: this.state.client._id,
        })

        await this.contractApi.update(contract)
        this.props.history.push({
          pathname: `/clients/${this.key}/contracts/${contract._key}/view`,
        })
      } catch (error) {
        console.error(error)
        message.error(error.errorMessage)
      }
      this.setState({ submitting: false })
    }
  }
  checkOverviewForm = () => {
    return new Promise((res, rej) => {
      this.overviewCmpRef.current.validateFields((err, values) => {
        if (!err) {
          this.setState({
            contract: _.merge(this.state.contract, values),
          })
          res(true)
        } else {
          const values = this.overviewCmpRef.current.getFieldsValue()
          this.setState({
            contract: _.merge(this.state.contract, values),
          })
        }
      })
    })
  }
  checkKeyTermsForm = () => {
    return new Promise((res, rej) => {
      this.keyTermsCmpRef.current.validateFields((err, values) => {
        if (!err) {
          this.setState({
            contract: Object.assign({}, this.state.contract, values),
          })
          res(true)
        } else {
          this.setState({
            contract: Object.assign({}, this.state.contract, values),
          })
        }
      })
    })
  }
  checkPaymentForm = () => {
    return new Promise((res, rej) => {
      this.payrollCmpRef.current.validateFields((err, values) => {
        if (!err) {
          this.setState((prevState) => ({
            contract: { ...prevState.contract, ...values },
          }))
          res(true)
        }
      })
    })
  }
  checkCommunicationForm = () => {
    return new Promise((res, rej) => {
      this.communicationCmpRef.current.validateFields((err, values) => {
        if (!err) {
          this.setState({
            contract: Object.assign({}, this.state.contract, values),
          })
          res(true)
        } else {
          const values = this.communicationCmpRef.current.getFieldsValue()
          this.setState({
            contract: Object.assign({}, this.state.contract, values),
          })
        }
      })
    })
  }
  handleCancel = () => {
    this.setState({ visible: false })
    this.props.handleCancel()
  }

  render() {
    return (
      <AddContract
        {...this.state}
        {...pick(this, [
          'updateContract',
          'prev',
          'next',
          'skip',
          'submit',
          'update',
          'checkOverviewForm',
          'checkKeyTermsForm',
          'checkPaymentForm',
          'checkCommunicationForm',
          'handleCancel',
          'overviewCmpRef',
          'keyTermsCmpRef',
          'payrollCmpRef',
          'ratesCmpRef',
          'linesCmpRef',
          'deliveryCmpRef',
          'communicationCmpRef',
        ])}
      />
    )
  }
}

AddContractCont.propTypes = {}
AddContractCont.defaultProps = {}

export default withRouter(AddContractCont)
